import React from 'react';
import { StyledContainer } from './styles';

/**
 * @component
 * @param {import('rsuite').ContainerProps} props
 * @returns {JSX.Element} Container component.
 */
export function Container({ children, ...props }) {
  return <StyledContainer {...props}>{children}</StyledContainer>;
}
